import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from 'src/app/shared/shared.module';

import { AuthenticationEffects } from '@authentication/store/authentication.effects';
import { AuthenticationFeature } from '@authentication/store/authentication.slice';

import { MerchantBasicDataReadonlyComponent } from './components/merchant-basic-data-readonly/merchant-basic-data-readonly.component';
import { MerchantBasicDataFormComponent } from './components/merchant-basic-data/merchant-basic-data-form/merchant-basic-data-form.component';
import { MerchantBasicDataComponent } from './components/merchant-basic-data/merchant-basic-data.component';
import { MerchantContactDataComponent } from './components/merchant-contact-data/merchant-contact-data.component';
import { MerchantImagePickerComponent } from './components/merchant-image-picker/merchant-image-picker.component';
import { MerchantMarketingDataCardComponent } from './components/merchant-marketing-data-card/merchant-marketing-data-card.component';
import { MerchantMarketingDataEditComponent } from './components/merchant-marketing-data-edit/merchant-marketing-data-edit.component';
import { MerchantMarketingDataListComponent } from './components/merchant-marketing-data-list/merchant-marketing-data-list.component';
import { MerchantSiteCardComponent } from './components/merchant-site-card/merchant-site-card.component';
import { MerchantSiteEditComponent } from './components/merchant-site-edit/merchant-site-edit.component';
import { MerchantSitesComponent } from './components/merchant-sites/merchant-sites.component';
import { MerchantTabsComponent } from './components/merchant-tabs/merchant-tabs.component';
import { MerchantTypeExciseSubformComponent } from './components/merchant-type-excise-subform/merchant-type-excise-subform.component';
import { MerchantTypeSubformComponent } from './components/merchant-type-subform/merchant-type-subform.component';
import { OtherContactsSubformComponent } from './components/other-contacts-subform/other-contacts-subform.component';
import { PackingMaterialsSubformComponent } from './components/packing-materials-subform/packing-materials-subform.component';
import { VisibleFieldsCheckboxComponent } from './components/visible-fields-checkbox/visible-fields-checkbox.component';
import { MerchantContainerComponent } from './containers/merchant-container/merchant-container.component';
import { MerchantSiteEditContainerComponent } from './containers/merchant-site-edit-container/merchant-site-edit-container.component';
import { MerchantRoutingModule } from './merchant-routing.module';
import { MerchantEffects } from './store/merchant.effects';
import { MerchantFeature } from './store/merchant.slice';

@NgModule({
  declarations: [
    MerchantBasicDataComponent,
    MerchantBasicDataFormComponent,
    MerchantBasicDataFormComponent,
    MerchantTabsComponent,
    MerchantContactDataComponent,
    MerchantContainerComponent,
    OtherContactsSubformComponent,
    MerchantSitesComponent,
    MerchantSiteCardComponent,
    MerchantSiteEditComponent,
    MerchantTypeSubformComponent,
    MerchantTypeExciseSubformComponent,
    MerchantMarketingDataEditComponent,
    MerchantMarketingDataListComponent,
    MerchantMarketingDataCardComponent,
    VisibleFieldsCheckboxComponent,
    MerchantSiteEditContainerComponent,
    PackingMaterialsSubformComponent,
    MerchantImagePickerComponent,
    MerchantBasicDataReadonlyComponent, // NOTE: see merchant-image-picker.component.ts:1
  ],
  imports: [
    CommonModule,
    MerchantRoutingModule,
    StoreModule.forFeature(MerchantFeature),
    EffectsModule.forFeature([MerchantEffects]),
    StoreModule.forFeature(AuthenticationFeature),
    EffectsModule.forFeature([AuthenticationEffects]),
    SharedModule,
  ],
  exports: [
    MerchantTabsComponent,
    MerchantBasicDataFormComponent,
    MerchantSiteEditComponent,
  ],
})
export class MerchantModule {}
